/**
 * Ecom module definition — activates when the website's pool settings flag
 * `ecom_active`.
 */

import type { SdkModuleDefinition } from '../types';
import { createEcomModuleApi, type EcomModuleApi } from './api';

export const ecomModule: SdkModuleDefinition<EcomModuleApi> = {
  id: 'ecom',
  isEnabled: (config) => config.ecom.active,
  install: (ctx) => createEcomModuleApi(ctx),
};
